<template>
  <div class="list-contents">

    <div class="list-card">
      <div class="list-info">

        <div v-for="item in tabViewData" class="list-item" :key="item.index">
          <h1>{{ item.title }}</h1>
          <p v-if="!editable">{{ item.val }} </p>
          <el-input v-model="item.val" size="mini" v-else></el-input>
          <!-- <p v-show="!item.val" style="color: #c0c4cc;">暂无数据</p> -->
          <!-- <div> {{ item }} </div> -->
          <!-- <el-select v-if="item.type === 3"  v-model="item.val" size="mini">
            <el-option v-for="enabled in item.options" :label="enabled.label" :value="enabled.value"
              :key="enabled.value"></el-option>
          </el-select>
          <el-input v-else readonly class="list-val" v-model="item.val" size="mini">
          </el-input> -->

        </div>
        <div class="list-item">
          <slot />
        </div>
      </div>


    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      EditCancel: this.$t("message.button.edit"),
      edit: false,
      input_width: {
        width: "50%",
      },

      tabViewData: [
        { title: '名称', val: '', attrs: 'name' },
        // { title: '类型', val: '', attrs: 'typeValue' },
        // { title: '状态', val: '可用', attrs: 'xx' },
        { title: '描述', val: '', attrs: 'description' },
        // { title: '更新日期', val: '', attrs: 'lastUpdated' },
      ],
      editForm: {},

      seekList: [],

      enabledList: [
        { label: this.$t("message.table.enabled"), value: 1 },
        { label: this.$t("message.table.disabled"), value: 0 },
      ],
      // listInfo: this.$route.query,
      // displayType:[
      //   {label: this.$t('message.table.list'),value:1},
      //   {label: this.$t('message.table.search'),value:2},
      // ],
      fontStyle: {
        color: '#ccc'
      }
    };
  },
  props: {
    data: {
      default: {},
      required: true,
    },
    editable: {
      default: false,
    }
  },
  methods: {
    editInfo() {
      this.edit = !this.edit;
    },
    getEditData() {
      return this.tabViewData;
    },

    getInfo() {
      this.tabViewData.forEach((i, e) => {
        const { attrs } = i;
        i.val = this.data[attrs] || ''
        this.$set(this.tabViewData, e, i)
      });
    },
  },

  created() {
    this.getInfo();

  },
  watch: {
    edit(e) {
      const str = e ? 'cancel' : 'edit';
      this.EditCancel = this.$t(`message.button.${str}`);
    },
    data(val) {
      console.log(val);
      this.getInfo();
    }
  },
};
</script>

<style scoped>
.list-contents {
  /* padding: 15px 30px; */
  background: #fff;
}

.list-contents .list-card {
  background: rgb(245, 247, 250);
  border-radius: 10px;
  display: flex;
  gap: 1.4em;
}

.list-info {
  flex: 1;
  display: flex;
  padding: 15px;
  /* justify-content: space-between; */
  align-items: center;

}

.list-info .list-item {
  border-right: 1px solid #e1e1e1;
  padding: 0 45px;
  font-size: 12px;
  flex: 1;
  align-items: center;
}

.disable {
  pointer-events: none;
}

h1 {
  margin-left: 3px;
  font-size: 12px;

}

.list-item .list-val {
  margin: 6px 0;
  color: #9b9b9b;

}

.list-item:last-child {
  border-right: none;
}

::v-deep .el-input--mini .el-input__inner {
  padding: 0 3px;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 30px;
  width: 150px;
}
</style>
